import ForgotPasswordContent from "../../../modules/Login/components/ForgotPasswordContent";
import { MobileAppForgotPasswordStyled } from "./styled/MobileAppForgotPasswordStyled";

function MobileAppForgotPassword() {
    return <MobileAppForgotPasswordStyled>
        <div className="d-flex flex-column w-100">
            <ForgotPasswordContent/>
        </div>
    </MobileAppForgotPasswordStyled>
}

export default MobileAppForgotPassword;
